import { SvgIconProps } from '@mui/material';
import { useFeatureFlag } from 'providers';
import PastaImage from 'assets/images/img-pasta.jpg';
import RedeemAndSavourImage from 'assets/images/img-redeem-and-savour-2.jpg';

function Pasta({ height = '120', width = '122', className }: SvgIconProps) {
  const allowSpinToWin = useFeatureFlag('allowSpinToWin');

  return (
    <>
      {allowSpinToWin ? (
        <svg
          viewBox="0 -10 111 109"
          width={width}
          height={height}
          fill="none"
          className={className}
        >
          <image width="100%" height="100%" xlinkHref={PastaImage} />
        </svg>
      ) : (
        <svg
          viewBox="0 -10 111 109"
          width={width}
          height={height}
          fill="none"
          className={className}
        >
          <path
            d="M5.584 53.893C-.79 43.634-2.024 30.043 3.534 18.84c1.501-3.026 3.804-5.583 6.16-8.016 2.833-2.926 5.838-5.77 9.427-7.72 8.154-4.43 21.942-3.316 30.677-1.56C93.28 10.285 84.21 85.744 38.16 74.944c-8.073-1.894-15.386-6.097-22.348-10.564-4.187-2.688-7.634-6.312-10.228-10.488Z"
            fill="url(#redeemAndSavour2_svg_a)"
          />
          <defs>
            <pattern
              id="redeemAndSavour2_svg_a"
              patternContentUnits="objectBoundingBox"
              width={1}
              height={1}
            >
              <use xlinkHref="#redeemAndSavour2_svg_b" transform="scale(.0007 .00057)" />
            </pattern>
            <image
              id="redeemAndSavour2_svg_b"
              width={1428}
              height={1756}
              xlinkHref={RedeemAndSavourImage}
            />
          </defs>
        </svg>
      )}
    </>
  );
}

export default Pasta;
